import { CircleAlert, Clock } from "lucide-react";
import type { LicenceStatus } from "../api/types.js";

/**
 * QASO licence banner (WP5b). Amber for expiring-soon / grace ("renew now") / degraded, red for
 * expired or no licence. Read-only: it explains what still works and how to renew; the API is the
 * enforcement authority. Renders nothing when there is nothing to say.
 */
export function LicenceBanner({ licence }: { licence: LicenceStatus | null | undefined }) {
  const banner = licence?.banner;
  if (!licence || !banner) return null;
  const Icon = banner.level === "red" ? CircleAlert : Clock;
  return (
    <div
      className={`inline-alert licence-banner licence-banner--${banner.level}`}
      role={banner.level === "red" ? "alert" : "status"}
      data-testid="licence-banner"
      data-licence-state={licence.state}
      data-licence-code={banner.code}
    >
      <Icon aria-hidden="true" size={16} />
      <span>{banner.message}</span>
    </div>
  );
}
